import { Component, Input, OnInit } from '@angular/core';
import { texts } from '../activity-item.texts';

@Component({
  standalone: false,
  selector: 'sc-activity-item-project-jobsite-confirmed',
  templateUrl: './activity-item-project-jobsite-confirmed.component.html',
  styleUrls: ['./activity-item-project-jobsite-confirmed.component.scss']
})
export class ActivityItemProjectJobsiteConfirmedComponent implements OnInit {
  
  @Input()
  activity : any;

  @Input()
  condensed = false;

  @Input()
  showProjectName = false;

  @Input()
  language: 'de' | 'en' = 'de';

  texts = texts;

  constructor() { }

  ngOnInit(): void {
  }

}
